<!-- Case loading -->
@if(this.matchStandingsService.isLoadingMatchStandings()) {
<app-skeleton-details-standings />
}

<!-- Case error -->
@if(this.matchStandingsService.isErrorMatchStandings()) {
<app-no-result message="NotAvalaibleInformation" />
}

<!-- Case loaded -->
@if (!this.matchStandingsService.isLoadingMatchStandings() &&
this.matchStandingsService.matchStandings()) {
<app-standings-table
  [standings]="this.matchStandingsService.matchStandings()!"
  [homeId]="homeId()"
  [awayId]="awayId()"
/>

}
